import request from '../request'

/**
 * 王者万象棋·各阵营禁用环境下 T0 阵容排行 数据接口。
 * 数据源：得到大脑(Get笔记)笔记《王者万象棋各阵营禁用环境下T0阵容排行与玩家讨论》
 */

/**
 * 获取全部模块数据（5 个禁用环境模块，每个模块含 columns 与 rows）。
 * 可选按「主力阵营」过滤（camp）：后端仅返回匹配该阵营的行，camp 为空返回全部。
 * @param {string} [camp] 主力阵营，如 '三分' / '无阵营'
 * @returns {Promise<Object>} { sourceNote, sourceNoteId, modules }
 */
export function fetchWzwxqData(camp) {
  return request({
    url: '/api/wzwxq',
    method: 'GET',
    params: camp ? { camp } : undefined,
  })
}

/**
 * 全量保存数据（前端编辑/新增行列后调用）。
 * @param {Object} payload 完整数据对象 { sourceNote, sourceNoteId, modules }
 * @returns {Promise<Object>} 保存后的数据
 */
export function saveWzwxqData(payload) {
  return request({
    url: '/api/wzwxq',
    method: 'PUT',
    data: payload,
  })
}

/**
 * 获取单个模块数据。
 * @param {string} key 模块 key（如 ban_heluo）
 * @returns {Promise<Object>} 模块对象 { key, title, columns, rows }
 */
export function fetchWzwxqModule(key) {
  return request({
    url: `/api/wzwxq/modules/${key}`,
    method: 'GET',
  })
}
